export default __webpack_public_path__ + "static/media/logo192.3c19a98c.png";